import { SingleValue } from "react-select";
import { SelectedBinListInBinGroup } from "./state";

export function initGroupNameTcAction(group_name_tc:string){
     return {
        type: "@@InitBinGroupListState/initGroupNameTcAction" as const,
        group_name_tc,
    };
}

export function initGroupNameEnAction(group_name_en:string){
     return {
        type: "@@InitBinGroupListState/initGroupNameEnAction" as const,
        group_name_en,
    };
}

export function ClearNewBinGroupAction(){
    return {
        type: "@@InitBinGroupListState/ClearNewBinGroupAction" as const,
        
    };
}
export function initSelectedBinInBinGroupAction(selectedBinInBinGroup:SelectedBinListInBinGroup[]){
     return {
        type: "@@InitBinGroupListState/initSelectedBinInBinGroupAction" as const,
        selectedBinInBinGroup,
    }

}

export function changeSelectedBinInBinGroupAction(newLocation:SingleValue<SelectedBinListInBinGroup>,original_bin_id:string){
    return {
        type: "@@InitBinGroupListState/changeSelectedBinInBinGroupAction" as const,
        newLocation,
        original_bin_id
    }
}

export function changeSelectedBinGroupSequenceAction(bin_group_sequence:string,bin_id:string){
  return {
        type: "@@InitBinGroupListState/changeSelectedBinGroupSequenceAction" as const,
        bin_group_sequence,
        bin_id
    }
}

export function changeBinGroupIsActiveAction(is_active:string){
  return {
        type: "@@InitBinGroupListState/changeBinGroupIsActiveAction" as const,
       is_active
    }
}

export const addBinToSelectedBinInBinGroupAction = (bin: SelectedBinListInBinGroup) => ({
  type: '@@BinGroup/addBinToSelectedBinInBinGroup' as const,
  bin
});

export const removeBinFromSelectedBinInBinGroupAction = (bin_id: string) => ({
  type: '@@BinGroup/removeBinFromSelectedBinInBinGroup' as const,
  bin_id
});



export type BinGroupListAction =
    | ReturnType<typeof initGroupNameTcAction>
     | ReturnType<typeof initGroupNameEnAction>
     | ReturnType<typeof ClearNewBinGroupAction>   
     | ReturnType<typeof initSelectedBinInBinGroupAction>
     | ReturnType<typeof changeSelectedBinInBinGroupAction>
     | ReturnType<typeof changeSelectedBinGroupSequenceAction>
     | ReturnType<typeof changeBinGroupIsActiveAction>
     | ReturnType<typeof addBinToSelectedBinInBinGroupAction>
     | ReturnType<typeof removeBinFromSelectedBinInBinGroupAction>